import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { provideRouter, withRouterConfig, withEnabledBlockingInitialNavigation } from '@angular/router'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { routes } from './app.routes'
import { provideClientHydration } from '@angular/platform-browser'
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http'
import { provideToastr } from 'ngx-toastr'
import { provideAnimations } from '@angular/platform-browser/animations'
import { APP_INITIALIZER } from '@angular/core'
import { AuthService } from './auth.service'
import { AuthInterceptorService } from './auth-interceptor.service'
import { LoadingService } from './shared/components/loading.service'

export function initApp(authService: AuthService) {
  return () => authService.loadSession() // promise-aware
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({
        canceledNavigationResolution: 'computed',
        defaultQueryParamsHandling: 'preserve',
        paramsInheritanceStrategy: 'always',
        resolveNavigationPromiseOnError: true,
        urlUpdateStrategy: 'eager',
        onSameUrlNavigation: 'reload',
      }),
      withEnabledBlockingInitialNavigation() // 👈 wait for APP_INITIALIZER
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    provideAnimationsAsync(),
    provideToastr(),
    provideClientHydration(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AuthService],
      multi: true,
    },
  ],
}
